module.exports = __webpack_public_path__ + "img/arrow-horizontal-purple.98c6728e.svg";